export const newReleases: DiskCollectionItem[] = [
  {
    type: "new",
    title: "Glider for Apple\u00A0II",
    lastUpdated: new Date("3/16/2025"),
    imageUrl: "https://www.colino.net/wordpress/wp-content/uploads/glider-splash.png",
    diskUrl: "https://colino.net/tmp/glider-en-beta-202503162.po",
    detailsUrl: "https://www.colino.net/wordpress/glider-for-apple-ii/",
    params: "color=green",
    fileSize: 143360
  },
  {
    type: "new",
    title: "Million Perfect Tiles",
    lastUpdated: new Date("12/30/2024"),
    imageUrl: "https://archive.org/download/MillionPerfectTiles/00playable_screenshot.png",
    diskUrl: "https://archive.org/download/MillionPerfectTiles/00playable.po",
    detailsUrl: "https://archive.org/details/MillionPerfectTiles",
    fileSize: 143360
  },
  {
    type: "new",
    title: "Encounter Adventure",
    lastUpdated: new Date("11/11/2024"),
    imageUrl: "https://www.brutaldeluxe.fr/products/apple2/encounter/title.jpg",
    diskUrl: "https://github.com/antoinevignau/source/raw/refs/heads/main/encounter/encounteradventure.dsk",
    detailsUrl: "https://www.brutaldeluxe.fr/products/apple2/encounter/",
    fileSize: 143360
  },
  {
    type: "new",
    title: "Undead Demo",
    lastUpdated: new Date("9/10/2024"),
    imageUrl: "https://www.callapple.org/wp-content/uploads/2024/09/Undead_Demo.png",
    diskUrl: "https://www.callapple.org/wp-content/uploads/2024/09/UNDEAD_DEMO.po_.zip",
    detailsUrl: "https://www.kickstarter.com/projects/8-bit-shack/undead-a-new-apple-role-player-game?utm_source=a2central",
    fileSize: 819200,
    exportDisabled: true
  },
  {
    type: "new",
    title: "Kontrabant",
    lastUpdated: new Date("4/10/2025"),
    imageUrl: "https://www.brutaldeluxe.fr/products/apple2/kontrabant/Kontrabant%20Box.jpg",
    diskUrl: "https://github.com/antoinevignau/source/raw/refs/heads/main/kontrabant/kontra_en.dsk",
    detailsUrl: "https://www.brutaldeluxe.fr/products/apple2/kontrabant/",
    fileSize: 819200
  },
  {
    type: "new",
    title: "Shufflepuck Cafe",
    lastUpdated: new Date("4/23/2025"),
    imageUrl: "https://www.colino.net/wordpress/wp-content/uploads/shufflepuck-cafe-bar.png",
    diskUrl: "https://github.com/colinleroy/a2tools/releases/latest/download/shufflepuck.po",
    detailsUrl: "https://www.colino.net/wordpress/en/shufflepuck-cafe-for-apple-ii/",
    params: "color=green",
    fileSize: 143360
  },
  {
    type: "new",
    title: "K2 Presentation",
    lastUpdated: new Date("5/2/2025"),
    imageUrl: "https://github.com/rsheehan/K2/raw/refs/heads/main/images/intro.png",
    diskUrl: "https://github.com/rsheehan/K2/raw/refs/heads/main/K2.po",
    detailsUrl: "https://github.com/rsheehan/K2",
    params: "TEXT=%2BK2%20ABOUTK2",
    fileSize: 143360
  },
  {
    type: "new",
    title: "A2DeskTop",
    lastUpdated: new Date("7/31/2025"),
    imageUrl: "https://github.com/ct6502/apple2ts/raw/refs/heads/main/public/disks/a2desktop.jpg",
    diskUrl: "https://a2desktop.s3.amazonaws.com/A2DeskTop-1.6-alpha4-en_800k.2mg",
    detailsUrl: "https://github.com/a2stuff/a2d",
    params: "color=color&speed=fast&scanlines=off&ramdisk=8192",
    fileSize: 819264,
    exportDisabled: true
  },
  {
      type: "new",
    title: "Quarx",
    lastUpdated: new Date("2/17/2026"),
    imageUrl: "https://i0.wp.com/www.the8bitguy.com/wp-content/uploads/2026/02/screenshot-01.png",
    diskUrl: "https://www.the8bitguy.com/wp-content/uploads/2026/02/Apple-II-Quarx-Shareware-02-16-2026.zip",
    detailsUrl: "https://www.the8bitguy.com/product/quarx-for-apple-iie-iic-iigs-and-laser-128/",
    fileSize: 143360,
  },
  {
    type: "new",
    title: "Sean's Garage Giveaway - demo",
    diskUrl: "GarageGiveaway-Demo.po",
    imageUrl: "disks/GarageGiveaway.png",
    helpFile: "GarageGiveaway.txt",
    detailsUrl: "https://www.8bitshack.net/seans-garage-giveaway",
    lastUpdated: new Date(0),
    fileSize: 143360,
  },
  {
    type: "new",
    title: "VERA Graphics & Sound Demo",
    lastUpdated: new Date("8/28/2026"),
    imageUrl: "disks/veratest.png",
    diskUrl: "https://github.com/anomixer/veratest/releases/latest/download/veratest.po",
    detailsUrl: "https://github.com/anomixer/veratest",
    params: "slot2=vera&tab=vera",
    fileSize: 143360
  },
  {
    type: "new",
    title: "VERA 256-Color Music Slideshow",
    lastUpdated: new Date("8/30/2026"),
    imageUrl: "disks/slideshow.png",
    diskUrl: "https://github.com/anomixer/veratest/releases/latest/download/slideshow.hdv.zip",
    detailsUrl: "https://github.com/anomixer/veratest",
    params: "slot2=vera&tab=vera",
    fileSize: 33553920
  },
  {
    type: "new",
    title: "Time Pilot (VERA)",
    lastUpdated: new Date("9/6/2026"),
    imageUrl: "disks/timepilot.png",
    diskUrl: "https://github.com/anomixer/Time-Pilot/releases/latest/download/TimePilot-IIvera.hdv",
    detailsUrl: "https://github.com/anomixer/Time-Pilot",
    params: "slot2=vera&tab=vera",
    fileSize: 819200
  },
  {
    type: "new",
    title: "Mine Rescue (H.E.R.O.) VERA",
    lastUpdated: new Date("10/4/2026"),
    imageUrl: "disks/minerescue.png",
    diskUrl: "https://github.com/anomixer/x16-hero-vera/releases/latest/download/x16-hero-vera.hdv",
    detailsUrl: "https://github.com/anomixer/x16-hero-vera",
    params: "slot2=vera&tab=vera&theme=dark",
    fileSize: 819200
  }
]
